export const ESTADO_CESION = {
  CREADA: 1,
  COMUNICADA: 2,
  ACEPTADA_MANUALMENTE: 3,
  ACEPTADA: 4,
  CANCELADA: 5,
  FINALIZADA: 6,
  RECHAZADA: 7,
} as const

export type EstadoCesionType =
  (typeof ESTADO_CESION)[keyof typeof ESTADO_CESION]
